export * from './confirm/confirm.component';
export * from './confirm/confirm-member.component';
export * from './confirm/survey-activate-error-message.component';
export * from './group-members/group-members.component';
export * from './task-performers/task-performers.component';
export * from './task-groups/task-groups.component';
export * from './task-notes/task-notes.component';
export * from './activate-user/activate-user.component';
export * from './notification-groups/notification-groups.component';
export * from './notification-recipients/notification-recipients.component';
export * from './add-edit-survey-questions/add-edit-survey-questions.component';
export * from './calendar/calendar-modal.component';
export * from './survey-submission/survey-submission.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/index.ts